// shared.module.ts

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ToolKitComponent } from '../Components/tool-kit/tool-kit.component';

@NgModule({
  declarations: [
    ToolKitComponent,
  ],
  imports: [
    CommonModule,
    RouterModule
  ],
  exports: [
    ToolKitComponent
  ]
})

export class ToolKitModule { }
